import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MappedServicesFilter from "../../../../elements/serviceReletionships/mappedServices/MappedServicesFilter";
import { DelayInput } from "react-delay-input/lib/Component";
import Dropdown from "rc-dropdown";
import DatePicker from "../../../../elements/datePicker/DatePicker";
import { getEndOfDayFromDate, getStartOfDayFromDate, TimestampToDate } from "../../../../../utils/timestampToDate";
import { CURRENCY_TYPE } from "../../../../../utils/consts";

import DefaultButton from "../../../../styles/materialButtonStyle";
import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledShowFilterBtn
} from "../../../../elements/filter/styledFiter";
import { StyledDatepicker } from "../../../../styles/styledDatepicker";


const ExchangeHistoryFilter = ({ filterData, setFilterData }) => {
  const { t } = useTranslation("exchangerPage");

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "itemsPerPage": filterData["itemsPerPage"] ?? null,
    "currentTab": filterData["currentTab"],
    "pair.user.email": "",
    "pair.user.nickname": "",
    "pair.exchangePair.inService.name": "",
    "pair.exchangePair.outService.name": "",
    "pair.exchangePair.inCurrency.asset": "",
    "pair.exchangePair.outCurrency.asset": "",
    "inAmount[gte]": "",
    "inAmount[lte]": "",
    "outAmount[gte]": "",
    "outAmount[lte]": "",
    "createdAt[gte]": null,
    "createdAt[lte]": null
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
  };

  const handleChangeFilterData = (data, name) => {
    setFilterData(prev => ({
      ...prev,
      [name]: data,
      page: 1
    }))
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
          <StyledFilterDropdownWrapper>
            <StyledFilterBlock actions>
              <StyledFilterGroup className="clear-btn">
                <DefaultButton
                  color="transparent"
                  onClick={handleClearFilter}
                >
                  {t("profitDetails.filter.clearBtn")}
                </DefaultButton>
              </StyledFilterGroup>
              <StyledFilterGroup className="clear-btn">
                <StyledFilterCloseBtn onClick={() => setVisible(false)} />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("profitDetails.filter.filterBy")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock col="2">
              <StyledFilterGroup>
                <label htmlFor="nickname">
                  Nickname
                </label>
                <DelayInput
                  id="nickname"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "pair.user.nickname": event.target.value, page: 1 })}
                  name="nickname"
                  value={filterData["pair.user.nickname"]}
                  type="text"
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <label htmlFor="pair.user.email">
                  {t("profitDetails.filter.client")}
                </label>
                <DelayInput
                  id="pair.user.email"
                  delayTimeout={2000}
                  onChange={event => setFilterData({
                    ...filterData,
                    "pair.user.email": event.target.value,
                    page: 1
                  })}
                  name="pair.user.email"
                  value={filterData["pair.user.email"]}
                  type="text"
                />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("profitDetails.filter.iGive")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock col="2">
              <MappedServicesFilter
                checkedService={filterData["pair.exchangePair.inService.name"]}
                setCheckedService={data => handleChangeFilterData(data, "pair.exchangePair.inService.name")}

                checkedCurrency={filterData["pair.exchangePair.inCurrency.asset"]}
                setCheckedCurrency={data => handleChangeFilterData(data, "pair.exchangePair.inCurrency.asset")}

                withoutCurrencyType={CURRENCY_TYPE.CRYPTO}
                withPaymentSystem={false}
              />
              <StyledFilterGroup>
                <label htmlFor="inAmount[gte]">
                  {t("profitDetails.filter.inAmountFrom")}
                </label>
                <DelayInput
                  id="inAmount[gte]"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "inAmount[gte]": event.target.value, page: 1 })}
                  name="inAmount[gte]"
                  value={filterData["inAmount[gte]"]}
                  type="text"
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <label htmlFor="inAmount[lte]">
                  {t("profitDetails.filter.inAmountTo")}
                </label>
                <DelayInput
                  id="inAmount[lte]"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "inAmount[lte]": event.target.value, page: 1 })}
                  name="inAmount[lte]"
                  value={filterData["inAmount[lte]"]}
                  type="text"
                />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("profitDetails.filter.iReceive")}
            </StyledFilterBlockTitle>
            <StyledFilterBlock col="2">
              <MappedServicesFilter
                checkedService={filterData["pair.exchangePair.outService.name"]}
                setCheckedService={data => handleChangeFilterData(data, "pair.exchangePair.outService.name")}

                checkedCurrency={filterData["pair.exchangePair.outCurrency.asset"]}
                setCheckedCurrency={data => handleChangeFilterData(data, "pair.exchangePair.outCurrency.asset")}

                withoutCurrencyType={CURRENCY_TYPE.CRYPTO}
                withPaymentSystem={false}
              />
              <StyledFilterGroup>
                <label htmlFor="outAmount[gte]">
                  {t("profitDetails.filter.outAmountFrom")}
                </label>
                <DelayInput
                  id="outAmount[gte]"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "outAmount[gte]": event.target.value, page: 1 })}
                  name="outAmount[gte]"
                  value={filterData["outAmount[gte]"]}
                  type="text"
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <label htmlFor="outAmount[lte]">
                  {t("profitDetails.filter.outAmountTo")}
                </label>
                <DelayInput
                  id="outAmount[lte]"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "outAmount[lte]": event.target.value, page: 1 })}
                  name="outAmount[lte]"
                  value={filterData["outAmount[lte]"]}
                  type="text"
                />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("profitDetails.filter.date")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock col="2">
              <StyledDatepicker>
                <label htmlFor="dateFrom">
                  {t("profitDetails.filter.dateFrom")}
                </label>
                <DatePicker
                  format="dd-MM-y"
                  id="dateFrom"
                  name="dateFrom"
                  className="date-input"
                  onChange={dateFrom => setFilterData({
                    ...filterData,
                    "createdAt[gte]": getStartOfDayFromDate(dateFrom),
                    page: 1
                  })}
                  value={TimestampToDate(filterData["createdAt[gte]"])}
                />
              </StyledDatepicker>
              <StyledDatepicker>
                <label htmlFor="dateTo">
                  {t("profitDetails.filter.dateTo")}
                </label>
                <DatePicker
                  format="dd-MM-y"
                  id="dateTo"
                  name="dateTo"
                  className="date-input"
                  onChange={dateTo => setFilterData({
                    ...filterData,
                    "createdAt[lte]": getEndOfDayFromDate(dateTo),
                    page: 1
                  })}
                  value={TimestampToDate(filterData["createdAt[lte]"])}
                />
              </StyledDatepicker>
            </StyledFilterBlock>
          </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        align={{ overflow: { adjustX: true, adjustY: false } }}
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("profitDetails.filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default ExchangeHistoryFilter;